/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createInterviewSlotRequest } from '../models/api_createInterviewSlotRequest';
import type { api_createInterviewSlotResponse } from '../models/api_createInterviewSlotResponse';
import type { db_GetInterviewSlotRow } from '../models/db_GetInterviewSlotRow';
import type { db_ListInterviewSlotsRow } from '../models/db_ListInterviewSlotsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InterviewSlots {
    /**
     * Get a list of interview slots
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListInterviewSlotsRow OK
     * @throws ApiError
     */
    public static listInterviewSlots(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListInterviewSlotsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-slots',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new interview slot
     * @param body Interview slot details
     * @returns api_createInterviewSlotResponse OK
     * @throws ApiError
     */
    public static createInterviewSlot(
        body: api_createInterviewSlotRequest,
    ): CancelablePromise<api_createInterviewSlotResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/interview-slots',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get interview slot details
     * @param id Interview slot ID
     * @returns db_GetInterviewSlotRow OK
     * @throws ApiError
     */
    public static getInterviewSlot(
        id: number,
    ): CancelablePromise<db_GetInterviewSlotRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interview-slots/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete an interview slot
     * @param id Interview slot ID
     * @returns void
     * @throws ApiError
     */
    public static deleteInterviewSlot(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/interview-slots/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
